import React, { useId } from "react";
import "./phone-input.scss";
import { COUNTRY_CODES, joinPhone, splitPhone } from "../../utils/phone";

// Phone field with a country-code dropdown. Value/onChange use the stored format "+60 12-345 6789".
const PhoneInput = ({ label, value, onChange, hint, required }) => {
  const id = useId();
  const { code, number } = splitPhone(value || "");

  return (
    <div className="form-field">
      <label className="form-field__label" htmlFor={`${id}-number`}>
        {label}
      </label>
      <div className="phone-input">
        <label className="visually-hidden" htmlFor={`${id}-code`}>
          Country code
        </label>
        <select
          id={`${id}-code`}
          className="form-field__control phone-input__code"
          value={code}
          onChange={(e) => onChange(`${e.target.value} ${number}`.trim())}
        >
          {COUNTRY_CODES.map((c) => (
            <option key={c.code} value={c.code} label={`${c.iso} ${c.code}`}>
              {c.iso} {c.code} ({c.country})
            </option>
          ))}
        </select>
        <input
          id={`${id}-number`}
          className="form-field__control phone-input__number"
          type="tel"
          inputMode="tel"
          autoComplete="tel-national"
          required={required}
          placeholder={code === "+60" ? "12-345 6789" : "Phone number"}
          value={number}
          // Keep what's typed (including a leading 0) and tidy it up when the field loses focus.
          onChange={(e) => onChange(`${code} ${e.target.value.replace(/[^\d\s-]/g, "")}`)}
          onBlur={() => onChange(joinPhone(code, number))}
        />
      </div>
      <span className="form-field__hint">{hint || "Enter the number without the leading 0."}</span>
    </div>
  );
};

export default PhoneInput;
